import { delayPromise } from "@bf-gameserver-client/utils/delayPromise";

export async function addScriptToHead(url: string, attempt = 0) {
	const script = document.createElement("script");
	script.defer = true;
	script.src = url;
	document.head.appendChild(script);

	const loaded = await new Promise(resolve => {
		script.onload = () => {
			resolve(true);
		};

		script.onerror = (error) => {
			console.error(JSON.stringify(error));
			console.error(`[addScriptToHead] loading failed ${url}:`, error);
			document.head.removeChild(script);

			if (attempt === 3) {
				throw new Error("[addScriptToHead] Cannot load script");
			}

			resolve(false);
		};
	});

	script.onload = null;
	script.onerror = null;

	if (loaded) {
		return;
	}

	// retry
	++attempt;

	const param = "&retry-attempt";
	let urlToRetry = url.replace(new RegExp(`${param}=\\d`), "") + `${param}=${attempt}`;
	if (!urlToRetry.includes("?")) {
		urlToRetry = urlToRetry.replace(param, `?${param}`);
	}

	const retryTimeout = Number(new URLSearchParams(window.location.search).get("retryBaseTimeout"));
	await delayPromise(retryTimeout || 3000);
	await addScriptToHead(urlToRetry, attempt);

}